var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMSmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 34,
    viewBox: "0 0 41 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_476_7172",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4338 0.275391H0V33.9731H40.4338V0.275391Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_476_7172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.506 21.2602C13.506 18.0532 13.5188 14.8478 13.5012 11.6409C13.4915 9.93467 14.1311 8.49697 15.2479 7.27433C17.1683 5.17356 19.1786 3.15524 21.0508 1.01404C21.9908 -0.0614199 24.5235 0.0420842 25.1952 1.65124C25.3158 1.93909 25.4073 2.26416 25.4089 2.57305C25.4169 8.93201 25.4267 15.2909 25.396 21.6483C25.3881 23.2865 24.6183 24.6758 23.5577 25.845C21.536 28.0719 19.4567 30.2439 17.366 32.4045C16.3487 33.4556 14.8639 33.5996 14.0138 32.6858C13.6763 32.322 13.5333 31.6525 13.5253 31.1188C13.4819 27.8325 13.5044 24.5448 13.5044 21.2585C13.5044 21.2585 13.506 21.2585 13.5076 21.2585L13.506 21.2602Z",
    fill: "url(#paint0_linear_476_7172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7615 12.203C38.7615 15.3016 38.7438 18.4002 38.7694 21.4988C38.7807 22.9771 38.3082 24.24 37.3119 25.3091C35.1521 27.6282 33.0101 29.9667 30.7988 32.2356C30.3248 32.7224 29.6161 33.1412 28.9605 33.2496C27.8163 33.4372 26.8859 32.4296 26.8842 31.1393C26.8746 24.5927 26.8713 18.0477 26.905 11.5011C26.9132 9.8936 27.5125 8.50279 28.6503 7.31412C30.5046 5.37506 32.3046 3.38426 34.098 1.38858C34.969 0.418255 35.9461 -0.0167798 37.2284 0.434426C38.2569 0.795068 38.7728 1.48725 38.7728 2.58535C38.7742 5.7923 38.7728 8.99766 38.7728 12.2046C38.7694 12.2046 38.7646 12.2046 38.7615 12.2046V12.203Z",
    fill: "url(#paint1_linear_476_7172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0678 19.4652C11.9103 24.54 12.2574 23.4096 9.3391 26.5891C7.66785 28.4086 5.99658 30.2295 4.28675 32.01C3.83519 32.4807 3.28558 32.9335 2.6926 33.1729C1.36685 33.7081 0.0539415 32.7669 0.0330506 31.3308C0.00894575 29.6878 -0.0440848 28.0398 0.0732252 26.4047C0.121435 25.7416 0.44444 24.98 0.887967 24.4852C3.46558 21.6081 6.12031 18.7989 8.73971 15.9591C9.2459 15.4092 9.78746 14.9645 10.5877 15C11.5182 15.0421 12.0597 15.5936 12.0662 16.5413C12.0742 17.6183 12.0678 18.6954 12.0678 19.4636V19.4652Z",
    fill: "url(#paint2_linear_476_7172)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_476_7172",
    x1: 1.94385,
    y1: 32.7561,
    x2: 42.7418,
    y2: 26.2244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#341572"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_476_7172",
    x1: 1.94391,
    y1: 32.7569,
    x2: 42.7418,
    y2: 26.2252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#341572"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_476_7172",
    x1: 1.94386,
    y1: 32.7562,
    x2: 42.7418,
    y2: 26.2244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#341572"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMSmallLogo);
export default __webpack_public_path__ + "static/media/MSmallLogo.814f4d7d1b80bb2f0fe79c6e44cd9db5.svg";
export { ForwardRef as ReactComponent };